import React from 'react';
import PropTypes from 'prop-types';

export function DisplayDivider(props) {
  return <div className={props.className} />;
}

DisplayDivider.propTypes = {
  /**
   * classname for component
   */
  className: PropTypes.string,
};
